import type { Brand } from "@shared/schema";

// Master-only brand grouping shared by the sidebar brand-switcher dropdown and
// the dashboard brand grid. The server strips clientCategory from brand
// payloads for non-masters, so this only ever produces headers for masters;
// group order is fixed, empty groups are hidden.
export const BRAND_CLIENT_CATEGORY_GROUPS: Array<{ key: string; label: string }> = [
  { key: "trial_users", label: "Trial Users" },
  { key: "demos", label: "Demos" },
  { key: "current_clients", label: "Current Clients" },
  { key: "smb_automated", label: "SMB" },
  { key: "previous_clients", label: "Previous Clients" },
  { key: "uncategorized", label: "Uncategorized" },
];

const brandNameCollator = new Intl.Collator(undefined, { sensitivity: "base" });

function compareBrandsByName(a: Brand, b: Brand): number {
  return brandNameCollator.compare(a.name, b.name) || a.id.localeCompare(b.id);
}

export function brandClientCategoryKey(brand: Brand): string {
  const raw = (brand as { clientCategory?: string | null }).clientCategory;
  return BRAND_CLIENT_CATEGORY_GROUPS.some((g) => g.key === raw)
    ? (raw as string)
    : "uncategorized";
}

export function groupBrandsByClientCategory(brands: Brand[]) {
  const byKey = new Map<string, Brand[]>();
  for (const brand of brands) {
    const key = brandClientCategoryKey(brand);
    const list = byKey.get(key);
    if (list) list.push(brand);
    else byKey.set(key, [brand]);
  }
  return BRAND_CLIENT_CATEGORY_GROUPS
    .map((g) => ({
      ...g,
      items: (byKey.get(g.key) ?? []).sort(compareBrandsByName),
    }))
    .filter((g) => g.items.length > 0);
}
